export default {
  namespaced: true,
  state: {
    charities: [],
    currentCharity: null
  },
  getters: {
    charities: state => {
      return [{
        name: 'Wells for Zoë',
        imageUrl: 'https://s3-eu-west-1.amazonaws.com/io.hirevibes.images/logos/logo-wells-for-zoe.png',
        tags: ['Clean Water', 'Education', 'Africa'],
        website: 'wellsforzoe.org',
        location: 'Dublin, Ireland',
        donations: {
          total: 20000.02,
          recent: 5000.05
        }
      }, {
        name: 'Charity Water',
        imageUrl: 'https://d1qb2nb5cznatu.cloudfront.net/startups/i/146431-a2fa514124011d809853a81de4329325-medium_jpg.jpg?buster=1355851792',
        tags: ['Clean Water', 'Construction', 'Africa'],
        website: 'charitywater.org',
        location: 'New York, USA',
        donations: {
          total: 20000.02,
          recent: 5000.05
        }
      }]
    }
  },
  mutations: {
    setCurrentCharity (state, to) {
    },
    resetCharities (state) {
      state.charities = []
    },
    resetCurrentCharity (state) {
      state.charity = null
    }
  },
  actions: {
    async getCharities ({ commit }) {
    },
    async getCharity ({ commit, getters }, charityId) {
      const charities = getters.charities

      charities.forEach((charity) => {
        if (charity.id === charityId) {
          commit('setCurrentCharity', charity)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/charities.js